var winheight = window.innerHeight;
var app;

function App() {
	var self = this;
	this.touch = Modernizr.touch;
	this.photoswipe = false;
	this.mq = false;
	this.init();
	this.foundation = $(document).foundation({
		equalizer : {
			equalize_on_stack: true,
		},
		interchange : {
			named_queries : {
    			small_retina : 'only screen and (min-width: 1px) and (-webkit-min-device-pixel-ratio: 2),only screen and (min-width: 1px) and (min--moz-device-pixel-ratio: 2),only screen and (min-width: 1px) and (-o-min-device-pixel-ratio: 2/1),only screen and (min-width: 1px) and (min-device-pixel-ratio: 2),only screen and (min-width: 1px) and (min-resolution: 192dpi),only screen and (min-width: 1px) and (min-resolution: 2dppx)',
				medium_retina : 'only screen and (min-width: 641px) and (-webkit-min-device-pixel-ratio: 2),only screen and (min-width: 641px) and (min--moz-device-pixel-ratio: 2),only screen and (min-width: 641px) and (-o-min-device-pixel-ratio: 2/1),only screen and (min-width: 641px) and (min-device-pixel-ratio: 2),only screen and (min-width: 641px) and (min-resolution: 192dpi),only screen and (min-width: 641px) and (min-resolution: 2dppx)',
				large_retina : 'only screen and (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2),only screen and (min-width: 1024px) and (min--moz-device-pixel-ratio: 2),only screen and (min-width: 1024px) and (-o-min-device-pixel-ratio: 2/1),only screen and (min-width: 1024px) and (min-device-pixel-ratio: 2),only screen and (min-width: 1024px) and (min-resolution: 192dpi),only screen and (min-width: 1024px) and (min-resolution: 2dppx)'
			}
		},
	});

	var BrowserDetect = {
        init: function () {
            this.browser = this.searchString(this.dataBrowser) || "Other";
            this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
        },
        searchString: function (data) {
            for (var i = 0; i < data.length; i++) {
                var dataString = data[i].string;
                this.versionSearchString = data[i].subString;

                if (dataString.indexOf(data[i].subString) !== -1) {
                    return data[i].identity;
                }
            }
        },
        searchVersion: function (dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index === -1) {
                return;
            }

            var rv = dataString.indexOf("rv:");
            if (this.versionSearchString === "Trident" && rv !== -1) {
                return parseFloat(dataString.substring(rv + 3));
            } else {
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            }
        },

        dataBrowser: [
            {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
            {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
            {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
            {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
            {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
            {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  

            {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
            {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
        ]
    };
    
    BrowserDetect.init();
    
    if (BrowserDetect.browser == 'MS Edge' || BrowserDetect.browser == 'Explorer') {
    	$('body').addClass('-ms');
    }
}

App.prototype.init = function() {
	var self = this;

	var ico_cookies_options = {
        target: $(".banner-wrapper .icons"),
        timeout: 0,
        cookiename: "icons",
    };

	this.handleWindowResize();
	this.slick = new Slick();
	this.cookies = new Cookies();
	this.ico_cookies = new Cookies(ico_cookies_options);
	this.menu = new Menu();
	this.search = new Search();
	this.NewsSearch = new NewsSearch();
	this.accordions = new Accordions();
	this.popups = new Popups();
	this.photoswipe = new initPhotoSwipe();
	this.ajax = new Ajax();
	this.callendar = new Callendar();
	this.formEvents = new FormEvents();
	this.form = new Form();
	this.fields = new Fields();
	this.fields2 = new Fields2(); //na wyszukiwarce
	this.fields3 = new Fields3(); //na glownej
	this.jobs = new Jobs();
	this.waypoints = new Waypoints();
	this.images = new ResponsiveBackgroundImage();
	this.wrapTables();
	this.handleSlickDotsPosition();
	this.handleFixedHeader();
	this.handleSplitFooterAddress();
	this.handleSearchInput();
	this.mobileShowCat();
	this.handleNewsFilters();
	this.handleMenuSelects();
	this.handleShowMoreButtons();
	this.handleShowMoreArrow();
	this.handleVideoMuteButton();
	this.handleVideoPauseButton();
	this.handleVideoPauseVisibility();
	this.handleCounter();
	this.handleAccessibility();
	this.handleCathedralsEvents();
	this.handleFieldsButtonSticky();

	this.wcagfinder = new WcagFinder();

	$(window).on('resize', this, this.handleWindowResize);
	$(window).on('resize', this, this.handleSlickDotsPosition);

	$('iframe:not(.no-wrapper)').wrap('<div class="iframe-wrapper"></div>');

	this.handleCustomScroll();

	this.registerServiceWorker();
};

App.prototype.saveAccessibility = function(font, contrast, cursor) {
	sessionStorage.setItem('accessibility', JSON.stringify({font: font, contrast: contrast, cursor: cursor}));
};

App.prototype.handleAccessibility = function() {
	var self = this;

	var font = parseInt($('html').attr('data-font'));
	var contrast = parseInt($('html').attr('data-contrast'));
	var cursor = parseInt($('html').attr('data-cursor'));

	$(document).on('click keydown scroll', function(e) {
		var $target = $(e.target);
		var $access = $('.accessibility');
		
		var clickInMenu = $target.closest('.accessibility').length > 0;
		var clickOnToggle = $target.closest('.accessibility-toggle').length > 0;

		$('#aria-font-up').toggleClass('-limit', font >= 6);
		$('#aria-font-down').toggleClass('-limit', font <= 1);
		if (font >= 6) {
			$('#aria-font-up').attr('tabindex', '-1');
		} else {
			$('#aria-font-up').attr('tabindex', '0');
		}
		if (font <= 1) {
			$('#aria-font-down').attr('tabindex', '-1');
		} else {
			$('#aria-font-down').attr('tabindex', '0');
		}

		if ($access.hasClass('-active') && !clickInMenu && !clickOnToggle) {
			$access.removeClass('-active');
			$('.accessibility-toggle').attr('aria-expanded', 'false');
			$('#accessibility-menu-id').attr('aria-hidden', 'true');
			$('.accessibility-menu-item').attr('tabindex', '-1');
		}
	});

	$('.accessibility-toggle').on('click keydown', function(e) {
		if(!e.key || e.key == "Enter") {
			$('.accessibility').toggleClass('-active');
			var isOpen = $('.accessibility').hasClass('-active');

			$(this).attr('aria-expanded', isOpen ? 'true' : 'false');
			$('#accessibility-menu-id').attr('aria-hidden', isOpen ? 'false' : 'true');
			$('.accessibility-menu-item').attr('tabindex', isOpen ? '0' : '-1');
		}
		if($('.accessibility').hasClass('-active')) {
			if(e.key == "Tab" && e.shiftKey) {
				e.preventDefault();
				$('.accessibility-menu-item:last-child').focus();
			}
		}
	});
	$('.accessibility-menu-item:last-child').on('keydown', function(e) {
		if(e.key == "Tab" && !e.shiftKey) {
			e.preventDefault();
			$('.accessibility-toggle').focus();
		}
	});

	$('#aria-font-up').on('click keydown', function(e) {
		if(!e.key || e.key == "Enter") {
			e.preventDefault();
			if (font < 6) {
				font++;
				$('html').attr('data-font', font);
			}
			self.saveAccessibility(font, contrast, cursor);
		}
	});
	$('#aria-font-down').on('click keydown', function(e) {
		if(!e.key || e.key == "Enter") {
			e.preventDefault();
			if (font > 1) {	
				font--;
				$('html').attr('data-font', font);
			}
			self.saveAccessibility(font, contrast, cursor);
		}
	});
	$('#aria-contrast').on('click keydown', function(e) {
		if(!e.key || e.key == "Enter") {
			e.preventDefault();
			if (contrast == '0') {
				contrast = '1';
				$('html').attr('data-contrast', contrast);
			} else {
				contrast = '0';
				$('html').attr('data-contrast', contrast);
			}
			self.saveAccessibility(font, contrast, cursor);
		}
	});
	$('#aria-cursor-up').on('click keydown', function(e) {
		if(!e.key || e.key == "Enter") {
			e.preventDefault();
			e.stopPropagation();
			cursor = '1';
			$('html').attr('data-cursor', cursor);
			self.saveAccessibility(font, contrast, cursor);
		}
	});
	$('#aria-cursor-down').on('click keydown', function(e) {
		if(!e.key || e.key == "Enter") {
			e.preventDefault();
			e.stopPropagation();
			cursor = '0';
			$('html').attr('data-cursor', cursor);
			self.saveAccessibility(font, contrast, cursor);
		}
	});
	$('#aria-reset').on('click keydown', function(e) {
		if(!e.key || e.key == "Enter") {
			e.preventDefault();
			e.stopPropagation();
			font = 1;
			contrast = 0;
			cursor = 0;
			$('html').attr('data-font', font);
			$('html').attr('data-contrast', contrast);
			$('html').attr('data-cursor', cursor);
			self.saveAccessibility(font, contrast, cursor);
		}
	});
};

App.prototype.handleCounter = function() {
	var self = this;
	$('.section--counter').each(function() {
		var countDownDate = new Date($(this).find('.counter-data').attr('data-time').replace(/-/g, "/")).getTime(),
			target = $(this),
			timer = 0;
		
		timer = setInterval(function() {
			var now = new Date().getTime();
			var timeleft = countDownDate - now;
			var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
			var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
			//console.log(countDownDate, now, timeleft, days, hours, minutes, seconds);

			target.find('.counter-data-item__days').text(days);
			target.find('.counter-data-item__hours').text(hours);
			target.find('.counter-data-item__minutes').text(minutes);
			target.find('.counter-data-item__seconds').text(seconds);
			if (days == 0 && hours == 0 && minutes == 0 && seconds ==0) {
				target.remove();
				clearInterval(timer);
			}
		}, 100);
	});
};

App.prototype.registerServiceWorker = function() {
	var self = this;

	if ('serviceWorker' in navigator) {
		window.addEventListener('load', function() {
			navigator.serviceWorker.register('/service-worker.js', {scope: '/'}).then(function(registration) {
				
				console.log('Registered!');
				
				if (('PushManager' in window)) {
					var permissions = window.Notification.requestPermission().then(function(permission) {
						
						// value of permission can be 'granted', 'default', 'denied'
					    // granted: user has accepted the request
					    // default: user has dismissed the notification permission popup by clicking on x
					    // denied: user has denied the request.
					    
					    if(permission !== 'granted'){
					        console.log('Permission not granted for Notification');
					    } else {
					    	// here you can add more properties like icon, image, vibrate, etc.
						    self.options = {
						        body: 'this is the message'
						    };
						    
						    // registration.showNotification('Test', self.options);
					    }
					});
				}
			}, function(err) {
				console.log('ServiceWorker registration failed: ', err);
			}).catch(function(err) {
				console.log(err);
			});

			navigator.serviceWorker.ready.then(function(swRegistration) {
				if (swRegistration.sync)
					return swRegistration.sync.register('event1');
			});
		});
	} else {
		console.log('service worker is not supported');
	}
};

App.prototype.handleCustomScroll = function() {
	var self = this;

	if (self.mq == 'large' || self.mq == 'xlarge') {
		$('.secondary-menu').each(function(){
			$(this).niceScroll({
				cursoropacitymax: 0.3,
				cursorborder: '2px solid #000',
				horizrailenabled: false,
				bouncescroll: true,
				autohidemode: true
			});
			$(this).on('touchmove', function(e) {
				e.preventDefault();
			});
		});

		$('.left-column .scroll-container').each(function(){
			var that = this;

			$(that).niceScroll({
				cursoropacitymax: 0.3,
				cursorborder: '2px solid #000',
				horizrailenabled: false,
				bouncescroll: true,
				autohidemode: true
			});
			$(that).on('touchmove', function(e) {
				e.preventDefault();
			});

			$(that).closest('.fixed-column').append(
		        $($(that).getNiceScroll()[0].rail[0]).addClass('-binded')
		    );
		    $(that).getNiceScroll().resize();
		});
	}
};

App.prototype.handleVideoMuteButton = function() {
	$('.mute').on('click', function(e) {
        e.preventDefault();
        if ($(this).siblings('video')[0].muted == true) {
            $(this).siblings('video')[0].muted = false;
            $(this).removeClass('-muted');
        } else {
            $(this).siblings('video')[0].muted = true;
            $(this).addClass('-muted');
        }
    });
};

App.prototype.handleVideoPauseButton = function() {
	$('.pause').on('click', function(e) {
        e.preventDefault();
        if ($(this).siblings('video')[0].paused) {
            $(this).siblings('video')[0].play();
            $(this).removeClass('-paused');
        } else {
            $(this).siblings('video')[0].pause();
            $(this).addClass('-paused');
        }
    });
};

App.prototype.handleVideoPauseVisibility = function() {
	$('.pause.-hidden').each(function() {
        var $pause = $(this);
        var video = $pause.siblings('video')[0];
        if (!video) {
            return;
        }
        var showIfLongEnough = function() {
            if (video.duration > 5) {
                $pause.removeClass('-hidden');
            }
        };
        if (video.readyState >= 1) {
            showIfLongEnough();
        } else {
            video.addEventListener('loadedmetadata', showIfLongEnough);
        }
    });
};

App.prototype.wrapTables = function() {
	var self = this;

	$('table').each(function() {
		if (!$(this).closest('.accordion').length) {
			if ($(this).outerWidth() > $(this).closest('section').outerWidth()) {
				$(this).wrap('<div class="table-wrapper"></div>');
			}
		}
	});
};

App.prototype.handleShowMoreButtons = function() {
	var self = this;

	$('.-quote').each(function() {
		var height = $(this).find('.text-container').outerHeight();

		if (height < 200) {
			$(this).find('.main-static-column').addClass('-dont-collapse');
		} else {
			$(this).find('.main-static-column').addClass('-collapsed');
		}

		$(this).find('.show-more').on('click', function(e) {
			e.preventDefault();
			if ($(this).closest('.main-static-column').hasClass('-collapsed')) {
				$(this).closest('.main-static-column').find('.text-container').css('max-height', height);
				$(this).text($(this).attr('data-less'));
				$(this).closest('.main-static-column').removeClass('-collapsed');
			} else {
				$(this).closest('.main-static-column').find('.text-container').removeAttr('style');
				$(this).text($(this).attr('data-more'));
				$(this).closest('.main-static-column').addClass('-collapsed');
			}
		});
	});

	$('.lecturer .more-button a').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.lecturer').toggleClass('-active');
	});
	$('.show-more-button a').on('click', function(e) {
		e.preventDefault();
		if ($(this).parent().attr('for')) {
			$('.'+$(this).parent().attr('for')).toggleClass('-active');
		}
	});
};

App.prototype.handleShowMoreArrow = function() {
    var $arrowDown = $('.scroll-more-arrow.-down');
	var $arrowUp = $('.scroll-more-arrow.-up');

	var height = $(window).height() * 0.9;

	function showArrow(elem) {
		$(elem).removeClass('-hide');
		$(elem).addClass('-show');
		$(elem).attr('tabindex', '0');
	}
	function hideArrow(elem) {
		$(elem).removeClass('-show');
		$(elem).addClass('-hide');
		$(elem).attr('tabindex', '-1');
	}

	function scrollTopCheck() {
		if($(document).scrollTop() === 0) {
			hideArrow($arrowUp);
		} else {
			showArrow($arrowUp);
		}
	}
	scrollTopCheck();

    $(window).on('scroll resize', function() {
		var $lastItem = $('.wpt:last') || $('.fields-category-item:last') || $('.search-index-item:last');

		if($lastItem) {
			if ($lastItem.hasClass('-active')) {
				hideArrow($arrowDown);
			} else {
				showArrow($arrowDown);
			}
		}
		scrollTopCheck();
    });

	$($arrowDown).on('click keydown', function(e) {
		e.preventDefault();
		if(!e.key || e.key === "Enter") {
			$('html, body').animate({
				scrollTop: $(window).scrollTop() + height
			}, 300);
		}
	});

	$($arrowUp).on('click keydown', function(e) {
		e.preventDefault();
		if(!e.key || e.key === "Enter") {
			$('html, body').animate({
				scrollTop: $(window).scrollTop() - height
			}, 300);
		}
	});
};

App.prototype.handleNewsFilters = function() {
    $('.filter-select').on('click keydown', '.filter-select-trigger', function(e) {
		if(!e.key || e.key == 'Enter') {
			e.preventDefault();
			e.stopPropagation();
			$(this).toggleClass('-active');

			if($(this).attr('aria-expanded') == 'false') {
				$(this).attr('aria-expanded', 'true');
			} else {
				$(this).attr('aria-expanded', 'false');
			}
		}

		if ((e.key === 'Tab' && e.shiftKey) || e.key == 'Escape') {
			if($(this).hasClass('-active')) {
				$(this).removeClass('-active').attr('aria-expanded', 'false');
			}
		}
	});

	$('.filter-select').on('keydown', '.filter-select-menu a', function(e) {
		var $trigger = $(this).closest('.filter-select-wrapper').find('.filter-select-trigger');
		var $menu = $(this).closest('.filter-select-wrapper').find('.filter-select-menu');
		var $links = $menu.find('a');

		if (e.key === 'Escape') {
			e.preventDefault();
			$trigger.removeClass('-active').attr('aria-expanded', 'false').focus();
		}

		if (e.key === 'Tab' && e.shiftKey && $(this).is($links.first())) {
			e.preventDefault();
			$trigger.removeClass('-active').attr('aria-expanded', 'false').focus();
		}

		if (e.key === 'Tab' && !e.shiftKey && $(this).is($links.last())) {
			$trigger.removeClass('-active').attr('aria-expanded', 'false');
		}
	});

	$(document).on('click', function(e) {
		e.stopPropagation();
		if (!$(e.target).closest('.filter-select').length) {
			$('.filter-select .filter-select-trigger').removeClass('-active').attr('aria-expanded', 'false');
		}
	});

	$('.filter-select').on('click', '.filter-select-menu', function(e) {
		e.stopPropagation();
	});

	$('.mobile-filter-trigger').on('click keydown', function(e) {
		if(!e.key || e.key == 'Enter') {
			e.preventDefault();
			var $filters = $('body').find('.mobile-filters');
			$filters.addClass('-active');
			$filters.find('.mobile-filters-content a').first().focus();
			$('body').css('overflow', 'hidden');
		}
	});

	$('.mobile-filters-header-close').on('click keydown', function(e) {
		if(!e.key || e.key == 'Enter') {
			e.preventDefault();
			$('.mobile-filters').removeClass('-active');
			$('body').css('overflow', 'auto');
		}
	});

	$('.mobile-filters').on('keydown', function(e) {
		if(e.key == 'Escape') {
			$(this).removeClass('-active');
			$('body').css('overflow', 'auto');
		}
	});

	$('.mobile-filters-content a').last().on('keydown', function(e) {
		if(e.key == 'Tab' && !e.shiftKey) {
			e.preventDefault();
			$('.mobile-filters').find('.mobile-filters-header-close').focus();
		}
	});

	$('.mobile-filters-header-close').on('keydown', function(e) {
		if(e.key == 'Tab' && e.shiftKey) {
			e.preventDefault();
			$('.mobile-filters-content a').last().focus();
		}
	});
};

App.prototype.handleMenuSelects = function() {
	var self = this;
	$('.select-menu > div').on('click', function(e) {
		e.stopPropagation();
		$(this).toggleClass('-active');
		$(this).siblings().removeClass('-active');

		if($(this).attr('aria-expanded') == 'false') {
			$(this).attr('aria-expanded', 'true');
		} else {
			$(this).attr('aria-expanded', 'false');
		}
	});
	$('.select-menu ul').on('click', function(e) {
		e.stopPropagation();
	});
	$('.select-menu .label').on('click', function(e) {
		e.preventDefault();
	});
	$('#lang-label').on('keydown', function(e) {
		if(e.key == "Tab" && e.shiftKey) {
			if($('.lang-menu').hasClass('-active')) {
				e.preventDefault();
				$('#lang-list a:last-of-type').focus();
			}
		}
	});
	$('#lang-list a:last-of-type').on('keydown', function(e) {
		if(e.key == "Tab" && !e.shiftKey) {
			e.preventDefault();
			$('#lang-label').focus();
		}
	});
	$(document).on('click', function() {
		$('.select-menu > div').removeClass('-active');
	});
};

App.prototype.handleFixedHeader = function() {
	var self = this;
	var page_container_height = 0;
	
	$(window).on('scroll', function() {
		//MAIN HEADER
		if ($(window).scrollTop() > 0) {
			$('.header').addClass('-fixed');
		} else {
			$('.header').removeClass('-fixed');
		}

		if (self.mq == 'large') {
			page_container_height = $('.page-container').outerHeight() + 160;
		} else if (self.mq == 'xlarge') {
			page_container_height = $('.page-container').outerHeight() + 180;
		}

		if (self.mq == 'large' || self.mq == 'xlarge') {
			if (page_container_height > $(window).outerHeight()) {
				if ($(window).scrollTop() + $(window).innerHeight() >= $('.footer').offset().top) {
					// $('.header').addClass('-hidden');
					$('.main-menu ul li').removeClass('-active');
					$('.subdomain-menu ul li').removeClass('-active');
					$('.subdomain-menu').removeClass('-active');
					$('.subdomain-menu-button').removeClass('-active');
					$('.select-menu > div').removeClass('-active');
					$('.filter.-listing').addClass('-top');
				} else {
					// $('.header').removeClass('-hidden');
					$('.filter.-listing').removeClass('-top');
				}
			}
		}
		//POKAZYWANIE MENU W FOOTERZE
		// if ((self.mq == 'large' || self.mq == 'xlarge')) {
		// 	if ($(window).scrollTop() + $(window).innerHeight() >= $('.footer').offset().top + ($('.footer').outerHeight()*0.4)) {
		// 		$('.footer-menu').addClass('-visible');
		// 		$('header.header').removeClass('-pink');
		//         $('header.header').removeClass('-red');
		//         $('header.header').removeClass('-blue');
		//         $('header.header').removeClass('-greenblue');
		// 	} else {
		// 		$('.footer-menu').removeClass('-visible');
		// 		$('.footer-subdomain-menu').removeClass('-active');
		// 		$('.footer-subdomain-menu-button').removeClass('-active');
		// 	}
		// }

		//POKAZYWANIE POZOSTALYCH DANYCH W FOOTERZE
		// if (self.mq == 'large' || self.mq == 'xlarge') {
		// 	if ($(window).scrollTop() + $(window).innerHeight() >= $('.footer').offset().top + ($('.footer').outerHeight()*0.6)) {
		// 		$('.footer-section').addClass('-visible');
		// 	} else {
		// 		$('.footer-section').removeClass('-visible');
		// 	}
		// }
	});
};

App.prototype.handleSplitFooterAddress = function() {
	var self = this;
	var $data = $('.footer-data-content > div').first().find('> ul > li').first();

	if($data.length) {
		var code = /[0-9]{2}-[0-9]{3}/;
		var text = $data.text();
		if(code.test(text)) {
			var replaced = text.replace(code, function(match) {
				return '<br>' + match;
			});
			$data.html(replaced);
		}
	}
};

App.prototype.handleSlickDotsPosition = function() {
	var self = this;

	var heightsArray = [];

	$('.slick-slider').find('.banner-item').each(function() {
		var colHeight = $(this).find('.column-left').innerHeight();
		heightsArray.push(parseInt(colHeight));
	});

    if (self.mq == 'medium' || self.mq == 'small') {
        var lowestTextHeight = Math.min.apply(Math, heightsArray);
        $('.slick-slider').find('.slick-dots').css('top', lowestTextHeight);
    }
};

App.prototype.mobileShowCat = function() {
	var self = this;
	$('body').on('click', '.mobile-show-categories', function(e) {
		e.preventDefault();
		if ($(this).siblings('.filter-items').hasClass('-active')) {
			$(this).siblings('.filter-items').removeClass('-active');
			$(this).removeClass('-open');
		} else {
			$(this).siblings('.filter-items').addClass('-active');
			$(this).addClass('-open');
		}
	});
};

App.prototype.handleSearchInput = function() {
	var self = this;

	var $search = $('.icon-panel .search');
	var $input = $('.icon-panel .search-overlay input');
	var $link = $('.icon-panel .search-overlay a');

	$link.on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		if ($(this).closest('.search').hasClass('-active')) {
			$(this).closest('.search').removeClass('-active');
			$input.attr('tabindex', '-1');

			if ($input.val() && $input.val() != "") {
				$(this).siblings('.search-form').submit();
			}
		} else {
			$(this).closest('.search').addClass('-active');
			$input.attr('tabindex', '0');
			$input.focus();
		}
	});

	$link.on('keydown', function(e) {
		if(e.key == "Tab" && !e.shiftKey) {
			if ($(this).closest('.search').hasClass('-active')) {
				e.preventDefault();
				$input.focus();
			}
		}
	});

	$input.on('click keydown', function(e) {
		e.stopPropagation();
		if(e.key == "Tab" && e.shiftKey) {
			if ($(this).closest('.search').hasClass('-active')) {
				e.preventDefault();
				$link.focus();
			}
		}
	});

	$(document).on('click', function() {
		$search.removeClass('-active');
		$input.attr('tabindex', '-1');
	});
};

App.prototype.handleCathedralsEvents = function() {
	var self = this;
	$('.fields-leads-trigger').on('click', function() {
		if ($('body').hasClass('-blue')) {
			var $content = $('.article-show-content');
			$content.find('.cathedrals-chairs-container, .bottom').addClass('-form');
		}
	});

	$('.cathedrals-fields-cities').each(function() {
		var $link = $(this).find('> a');

		$link.each(function(index, elem) {
			var $elem = $(elem);
			var val = $elem.text();

			if(val.length > 10 && val.indexOf(" ")) {
				$elem.addClass('-short');
			} 
		});
	});
};

App.prototype.handleFieldsButtonSticky = function() {
	var $elem = $('.fields-leads-trigger');
	var $cloned = $('.fields-leads-trigger-cloned');
	var $container = $('.content-column');

	var $box = $('.article-show-content');
	var $pageCon = $('.page-container');

	var conOffsetTop = ($container.length) ? $container.offset().top : 0;
	var columnOffsetBottom = conOffsetTop + $('.left-column').outerHeight() - $('.header').height();

	$(window).on('scroll resize', function() {
		var width = $(window).width();

		if (width <= 1200) {
			var scrollTop = $(window).scrollTop();
			var windowBottom = scrollTop + $(window).height();

			var widthToChange = width <= 767 ? 'calc(100% - 90px)' : 'calc(100% - 180px)';
			$cloned.css('width', widthToChange);

			if (!$elem.hasClass('-active')) {
				if (scrollTop > columnOffsetBottom) {
					$cloned.addClass('-active');
				} else {
					$cloned.removeClass('-active');
				}
			}

			if ($cloned.hasClass('-active')) {
				if (windowBottom > conOffsetTop + $container.outerHeight()) {
					$cloned.addClass('-hidden');
				} else {
					$cloned.removeClass('-hidden');
				}
			}
		}
	});

	$($cloned).on('click', function(e) {
		e.preventDefault();
		$elem.addClass('-active');
		$cloned.removeClass('-active');
		document.documentElement.scrollTop = $pageCon.outerHeight() - $box.outerHeight();
	});
};

App.prototype.handleWindowResize = function(e) {
	var self = this;
	winheight = window.innerHeight;
	self.mq = /\w+/g.exec(window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content'))[0];
};

$(document).ready(function() {
	app = new App();
});